/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import QuickToolsView from "components/quickTools/QuickToolsView";
import { inject } from "mobx-react";
import {
  getDisabledQuickToolsVerbs,
  getActiveVerb,
  getQuickToolsVerbs,
  getShowPrimaryPanel
} from "selectors/quickToolsSelectors";
import {
  getShouldRenderPersonalCommentsDropin,
  getShouldRenderCommentsDropin,
  getShouldRenderFillSignDropin
} from "selectors/overlayDropinSelectors";
import { getShouldShowCommentingTools } from "selectors/documentSelectors";
import { getShouldUseMobileModernViewer } from "selectors/appSelectors";
import { isCommentingAllowed } from "../../utils/DocPermissionsUtils";
import { getCurrentNotificationBannerHeight, getShouldRenderBannerBeforeDoc } from "selectors/notificationSelectors";
import { QUICK_TOOLS_BORDER_RADIUS, QUICK_TOOLS_MARGIN_TOP } from "constants/constants";

const getQuickToolsTop = stores => {
  const shouldRenderBannerBeforeDoc = getShouldRenderBannerBeforeDoc(stores);
  const currentNotificationBannerHeight = getCurrentNotificationBannerHeight(stores);
  const bannerOffset = shouldRenderBannerBeforeDoc ? 0 : currentNotificationBannerHeight;
  return isNaN(bannerOffset) ? QUICK_TOOLS_MARGIN_TOP : bannerOffset + QUICK_TOOLS_MARGIN_TOP;
};

const mapStoreToProps = (stores, ownProps) => ({
  activeVerb: getActiveVerb(stores),
  enableFillSignQuickTools: getShouldRenderFillSignDropin(stores),
  shouldShowCommentingTools: getShouldShowCommentingTools(stores),
  quickToolsVerbs: getQuickToolsVerbs(stores),
  disabledVerbs: getDisabledQuickToolsVerbs(stores),
  id: ownProps.id,
  previewConfig: (() => ({
    shouldRenderPersonalCommentsDropin: getShouldRenderPersonalCommentsDropin(stores),
    shouldRenderCommentsDropin: getShouldRenderCommentsDropin(stores),
    isCommentingAllowed: isCommentingAllowed()
  }))(),
  setIsFocusOverQuickTools: value => stores.quickToolsStore.setIsFocusOverQuickTool(value),
  setIsClickedByMouse: value => stores.quickToolsStore.setIsClickedByMouse(value),
  showPrimaryPanel: getShowPrimaryPanel(stores),
  shouldUseMobileModernViewer: getShouldUseMobileModernViewer(stores),
  style: {
    borderRadius: `${QUICK_TOOLS_BORDER_RADIUS}px`,
    top: `${getQuickToolsTop(stores)}px`
  }
});

const QuickToolsContainer = inject(mapStoreToProps)(QuickToolsView);

export { QuickToolsContainer };
